import { stringify } from 'qs';
import request from '@/utils/request';
import { loginOrg, loginUser, loginCompany } from '@/utils/LoginContext';

export async function saveOrModify(payload) {
  return request(`/iwms-basic/basic/vendorDcRemark`,{
    method:'POST',
    body:payload
  })
}

export async function getByVendorUuid(payload) {
  return request(`/iwms-basic/basic/vendorDcRemark/${payload.vendorUuid}?dcUuid=${loginOrg().uuid}`)
}
